import { fetchJSON } from "../utilities/fetch";

interface SearchProps {
    query?: string;
    pageType?: string;
    pageNumber?: number;
    limit?: number;
    category?: number;
    tag?: string;
}
interface ResponseDoc {
    id;
    path;
    title;
    description;
}

interface SearchResponse {
    docs: ResponseDoc[];
    numFound: number;
    start: number;
}

export function search({ query, pageType, pageNumber, limit, category, tag }: SearchProps): Promise<SearchResponse> {
    const params = [];
    params.push(`q=${query || ''}`); // q is required even if blank
    if (pageType) {
        params.push(`pt=${pageType}`);
    }
    if (pageNumber) {
        params.push(`page=${pageNumber}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (category) {
        params.push(`cat=${category}`);
    }
    if (tag) {
        params.push(`tag=${tag}`);
    }
    const cacheBypassParam = `clientCacheBypass=${Math.floor(Date.now() / parseInt(process.env.SOLR_CACHE_INTERVAL_MS || '900001'))}`; // create a param to bypass the cache every 15 minutes
    params.push(cacheBypassParam);

    return fetchJSON<any[any]>(`${process.env.GATSBY_SOLR_SEARCH_URL}?${params.join('&')}`)
        .then(({ response }) => response);
}
